export const formatCommaNumber = (raw: string | null | undefined): string => {
  if (!raw) return '';
  const num = Number(raw);
  return Number.isFinite(num) ? num.toLocaleString() : raw;
};

export const formatCompactNumber = (
  value: number,
  signDisplay: Intl.NumberFormatOptions['signDisplay'] = 'auto',
): string =>
  new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1, signDisplay })
    .format(value)
    .toLowerCase();
